import { Injectable } from '@angular/core';
import { IRedirect } from './redirect.interface';
import { Router } from '@angular/router';
import { PageService } from '../page.service';
import { RedirectService } from '../redirect.service';

@Injectable({ providedIn: 'root' })
export class LastRedirectService implements IRedirect {
	private urlWithoutRedirection = ['/coleta'];

	constructor(private router: Router, private pageService: PageService, private redirectService: RedirectService) {}

	redirect = async () => {
		const url = this.pageService.currentUrl || (await this.pageService.getFirstUrl.toPromise());
		if (url === '/') {
			this.redirectService.goToHome();
			return Promise.resolve(true);
		}
		return Promise.resolve(false);
	};
}
